import React, { useState, useEffect } from "react";
import Form from "./components/Form";
import ListImages from "./components/ListImages";

function App() {
  const [search, searchItem] = useState("");
  const [images, setImages] = useState([]);
  //
  const [page, pageCurrent] = useState(1);
  const [totalpage, setTotal] = useState(1);
  

  useEffect(() => {
    const consultApi = async () => {
      if (search === "") return;

      const Images_page = 30;
      const key = "16201423-a634c0ed2c55e70b4b57671e4";
      const url = `https://pixabay.com/api/?key=${key}&q=${search}&per_page=${Images_page}&page=${page}`;
      const answer = await fetch(url);
      const outcome = await answer.json();
      setImages(outcome.hits);
      //calcular total de paginas a mostar
      const paginas = Math.ceil(outcome.totalHits / Images_page);
      setTotal(paginas);
      
    };
    consultApi();
  }, [search, page]);

  //definir la pagina aneterior
  const pagePrevius = () => {
    const newPage = page - 1;
    if (newPage === 0) return;
    pageCurrent(newPage);
  };
  //definir pagina siquiente
  const pageNext = () => {
    const newPage = page + 1;
    if (newPage > totalpage) return;
    pageCurrent(newPage);
  }
  return (
    <div className="container">
      <div className="jumbotron">
        <div className="lead text-center">Buscador de Imagenes</div>
        <Form searchItem={searchItem} />
      </div>
      <div className="row justify-content-center ">
        <ListImages images={images} />
        <button
          className="btn btn-info mr-1"
          type="button"
          onClick={pagePrevius}
        >
          &laquo;Anterior
        </button>
        <button
          className="btn btn-info "
          type="button"
          onClick={pageNext}
        >
          Siquiente &raquo;
        </button>
      </div>
    </div>
  );
}

export default App;
